export const ALERTS = 'alerts';
export const EMERGENCY_CALLS = 'calls';
export const NON_CALLS = 'non_calls';
export const AGENCY_CHAT = 'agency_chat';

export type IncidentType =
  | typeof AGENCY_CHAT
  | typeof ALERTS
  | typeof EMERGENCY_CALLS
  | typeof NON_CALLS;
